import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import {
  ReaChangeDigestItem,
  ReaFieldChange,
  ReaImportChange,
  ReaReviewReasonItem,
  ReaSuggestedMapLayer,
} from 'src/app/models/fincas/rea.model';

/**
 * Groups secondary review information so the main modal remains focused.
 */
@Component({
  selector: 'app-rea-import-optional-review',
  templateUrl: './rea-import-optional-review.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ReaImportOptionalReviewComponent {
  @Input()
  public hasMapInsights = false;

  @Input()
  public suggestedMapLayers: ReaSuggestedMapLayer[] = [];

  @Input()
  public changesTruncated = false;

  @Input()
  public recentChanges: ReaImportChange[] = [];

  @Input()
  public changeDigestMetrics: ReaChangeDigestItem[] = [];

  @Input()
  public reviewReasons: ReaReviewReasonItem[] = [];

  @Input()
  public reviewRequiredCount = 0;

  @Output()
  public readonly reviewRequested = new EventEmitter<ReaReviewReasonItem[]>();

  public get reviewRequiredLabel(): string {
    if (this.reviewRequiredCount <= 0) {
      return '';
    }

    return this.reviewRequiredCount === 1
      ? 'El resumen marca 1 parcela para revisar.'
      : `El resumen marca ${this.reviewRequiredCount} parcelas para revisar.`;
  }

  public get visibleChangeDigestMetrics(): ReaChangeDigestItem[] {
    return this.changeDigestMetrics.filter((item) => item.visible);
  }

  public get visibleRecentChanges(): ReaImportChange[] {
    return this.recentChanges.filter((change) => this.isVisibleRecentChange(change));
  }

  public get hasOptionalReview(): boolean {
    return this.reviewReasons.length > 0 || this.hasMapInsights || this.visibleRecentChanges.length > 0 || this.changesTruncated;
  }

  public fieldChangesFor(change: ReaImportChange): ReaFieldChange[] {
    return Array.isArray(change.fieldChanges) ? change.fieldChanges : [];
  }

  public get reviewHeadline(): string {
    return 'Motivos de revisión detectados';
  }

  public hasFieldChanges(change: ReaImportChange): boolean {
    return this.fieldChangesFor(change).length > 0;
  }

  public requestReview(): void {
    this.reviewRequested.emit(this.reviewReasons);
  }

  private isVisibleRecentChange(change: ReaImportChange): boolean {
    return change.action !== 'unchanged' && (change.messages.length > 0 || this.hasFieldChanges(change));
  }
}

